import _ from 'underscore';

import Choices from 'choices.js/public/assets/scripts/choices.min.js';
import 'choices.js/public/assets/styles/choices.min.css';
import { Rules , NodeType} from './rules.js';


var menuTemplate = require("../../../../templates/rules.handlebars");

const RULE = "rules";

export default class RuleMenu {

	constructor(api, siteData) {
		this.name = 'RuleMenu';
        this.siteData = siteData;
		this.selectedFeature;
		this.configredRule;
        this.floorRule;
        this.rule;
	}

	toString() {
        return this.name;
    }


    initMenu(){
        $("#rules-body").html("");
    	$("#rules-body").append(menuTemplate);
        this.rule = new Rules();
        var _this = this;
        var choices = _.filter(this.siteData.floors, function(floor){ return floor.value != _this.siteData.floor_identifier; });

    	this.floorRule = new Choices(document.getElementById('FloorRules'),{
            choices : choices,
            paste: false,
            removeItemButton: true
        });

        

        // rule select
    }

    onEditNode(){
        if(this.configredRule.type == 'lift'){
            this.floorRule.setValue(this.configredRule.getFloors());
        }
        this.configRuleSection();
    }

    
    configRuleSection(){
        if(this.configredRule && this.configredRule.isLift()){
            this.showLifteRule();
            this.hideEscalatorRule();
            this.hideEmptyView();
        } else {
            this.hideLifteRule();
            this.hideEscalatorRule();
            this.showEmptyView();
        }
    }

    showLifteRule(){
        $("#lift-rule").show();
    }

    hideLifteRule(){
        $("#lift-rule").hide();
    }

    showEscalatorRule(){
        $("#escalator-rule").show();
    }

    hideEscalatorRule(){
        $("#escalator-rule").hide();
    }

    showEmptyView(){
        $("#empty-view").show();
    }

    hideEmptyView(){
        $("#empty-view").hide();
    }

    open(feature){
    	this.initMenu();
        this.selectedFeature = feature;
        if(feature.getProperties() && feature.getProperties().rule){
            var rule = new Rules();
            rule.setType(feature.getProperties().rule.type);
            rule.setFloors(feature.getProperties().rule.selectedFloors);
            this.configredRule = rule;
            this.onEditNode();
        }
    }

    save(selectedPoint){
    	$("#rule-side-menu").remove();
        let props = {};
        if(this.rule && selectedPoint){
            this.rule.setType(selectedPoint);
            var selectedData = [];
            if(selectedPoint == 'lift'){
                _(this.floorRule.getValue()).each(function(floor){
                    selectedData.push({
                        label : floor.label,
                        value : floor.value
                    });
                }); 
            }
            
            this.rule.setFloors(selectedData);
            if(this.selectedFeature) props['rule'] = this.rule;
            this.selectedFeature.setProperties(props);
        }
        
    }

    static get getRuleVariable() {
        return RULE;
    }

}